import moment from 'moment';
import { SectionController } from '../SectionController';
import { ReviewPage } from '../../../services/ReviewService';
import { ItemGroupId } from '../../../models/ItemGroup';
import { ReviewItemId } from '../../../models/ReviewItem';

class PersonalDetailsController extends SectionController {
    applicationFormOptions: any = {}
;
	availability: any;
	contactDetails: any;
	emergencyContact: any;
    drivingDetails: any;
    isOfficeUser: boolean;
    isApplicant: boolean;
    page: ReviewPage;

	fields: any[];

    applicationStatus: string;

    static override $inject = ['$rootScope', '$scope', '$q', 'dialogs', 'Availability', 'ContactDetails', 'EmergencyContact', 'Driving', 'personalDetailsPage', 'applicationId', 'review', 'ApproveChanges', 'Auth', 'ReevaluateSection', 'applicationObservable'];
    constructor($rootScope, $scope, private $q: ng.IQService, dialogs, private Availability, private ContactDetails, private EmergencyContact, private Driving, personalDetailsPage, applicationId, review, private ApproveChanges, Auth, ReevaluateSection, applicationObservable) {
        super($rootScope, $scope, Auth, ReevaluateSection, review, applicationId, ItemGroupId.PersonalDetails, applicationObservable, dialogs);

		var getCountry = () => this.contactDetails.country;

		this.availability = personalDetailsPage.availability;

		this.contactDetails = personalDetailsPage.contact;
		this.contactDetails.getCountry = getCountry;

		this.emergencyContact = personalDetailsPage.emergencyContact;
		this.emergencyContact.getCountry = getCountry

		this.drivingDetails = personalDetailsPage.driving;
        this.drivingDetails.currentDate = moment().startOf('day').toDate();

        this.isOfficeUser = Auth.user.isOfficer;
        this.isApplicant = Auth.user.isApplicant;

        this.page = review.getPage(ItemGroupId.PersonalDetails);

        applicationObservable.subscribe(i => {
            this.applicationStatus = i.status;
        })

        $scope.$watch(() => this.$scope.personalDetailsForm.$dirty, () => {
            this.$dirty = this.$scope.personalDetailsForm.$dirty
        })

        $scope.$on('personalDetails:refresh', (nam, type, data) => {
            this.refreshSection(type, data);
        })


        $scope.$watch(() => this.contactDetails.telephoneOne.isMobile, (val) => {
            this.checkandSetShowHostFamilyOpt();
        })
        $scope.$watch(() => this.contactDetails.telephoneTwo.isMobile, (val) => {
            this.checkandSetShowHostFamilyOpt();
        })

        this.$scope.$on(`sectionChangedByApplicantSN`, (event, data) => {
            this.save(data);
        });
    }

    checkandSetShowHostFamilyOpt() {
        this.contactDetails.showHFsmsOptIn = this.contactDetails.telephoneOne.isMobile || this.contactDetails.telephoneTwo.isMobile;
    }


    refreshSection(type, data) {
        var getCountry = () => this.contactDetails.country;
        switch (type) {
            case ReviewItemId.YourAvailability:
                this.availability = data;
                break;
            case ReviewItemId.ContactDetails:
                this.contactDetails = data;
                this.contactDetails.getCountry = getCountry;
                break;
            case ReviewItemId.EmergencyContactDetails:
                this.emergencyContact = data;
                this.emergencyContact.getCountry = getCountry;
                break;
            case ReviewItemId.DrivingDetails:
                this.drivingDetails = data;
                this.drivingDetails.currentDate = moment().startOf('day').toDate();
                break;
            default:
                break;
        }
    }

    save(data) {
		this.$scope.$broadcast('submitted', true);

		var promisses = [];
		var form = this.$scope.personalDetailsForm;		

        if (form['ContactDetails'].$dirty) {
            this.contactDetails.metaform = form['ContactDetails'].$metaformVersion;
            promisses.push(
                this.ContactDetails.update(this.contactDetails)
                    .$promise
                    .then(() => this.sectionChanged(ReviewItemId.ContactDetails, undefined, data?.isDone))
            );
        }

        if (form['DrivingDetails'].$dirty) {
            this.drivingDetails.metaform = form['DrivingDetails'].$metaformVersion;
            promisses.push(
                this.Driving.update(this.drivingDetails)
                    .$promise
                    .then(() => this.sectionChanged(ReviewItemId.DrivingDetails, undefined, data?.isDone))
            );
        }	

        if (form['Availability'].$dirty) {
            this.availability.metaform = form['Availability'].$metaformVersion;
            promisses.push(
                this.Availability.update(this.availability)
                    .$promise
                    .then(() => this.sectionChanged(ReviewItemId.YourAvailability, undefined, data?.isDone))
            );
        }

        if (form['EmergencyContactDetails'].$dirty) {
            this.emergencyContact.metaform = form['EmergencyContactDetails'].$metaformVersion;
            promisses.push(
                this.EmergencyContact.update(this.emergencyContact)
                    .$promise
                    .then(() => this.sectionChanged(ReviewItemId.EmergencyContactDetails, undefined, data?.isDone))
            );
        }

        if (promisses.length == 0) {
            this.$scope.$broadcast(`noChangeInForm`, { isDone: true, reviewItemId: data.reviewItemId });
            return;
        }
        
		this.$q.all(promisses)
			.then(() => {
                form.$setPristine();

                //TODO move this to parent class and remove saved flag
                this.alerts.push({ // TODO should I be able to display the same message twice?
                    type: 'success',
                    msg: 'Save complete',
                    dismissOnTimeout: 5000
                })
			}, () => {
                //TODO move this to parent class and remove saved flag
                this.alerts.push({ // TODO should I be able to display the same message twice?
                    type: 'danger',
                    msg: 'We are sorry but your form could not be saved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                    dismissOnTimeout: 20000
                })
			});
    }
}


angular
	.module('app')
	.controller('PersonalDetailsController', PersonalDetailsController);